import { atom } from 'jotai';
import { CurrencyIsoCode } from 'shared/data/wallets/v1';

export const convertCurrencyPopupState = atom<{
    isOpen: boolean;
    fromDefaultCurrency?: CurrencyIsoCode;
    toDefaultCurrency?: CurrencyIsoCode;
}>({
    isOpen: false,
});
